/* product image slider */
(function () {
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-track]');
    if (!track) return;
    var prev = slider.querySelector('[data-prev]');
    var next = slider.querySelector('[data-next]');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dot]'));

    function slideWidth() { return track.clientWidth; }
    function currentIndex() { return Math.round(track.scrollLeft / slideWidth()); }
    function goTo(i) {
      var count = track.children.length;
      if (i < 0) i = count - 1;
      if (i > count - 1) i = 0;
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
    }
    function syncDots() {
      var i = currentIndex();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(syncDots, 60);
    }, { passive: true });

    /* mouse drag-to-swipe (touch swiping is native) */
    var isDown = false, moved = false, startX = 0, startScroll = 0;

    track.querySelectorAll('img').forEach(function (img) { img.draggable = false; });

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      track.scrollLeft = startScroll - delta;
    });

    window.addEventListener('mouseup', function (e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (moved) {
        var delta = e.clientX - startX;
        var i = Math.round(startScroll / slideWidth());
        if (delta < -40) i += 1;
        else if (delta > 40) i -= 1;
        var count = track.children.length;
        if (i < 0) i = 0;
        if (i > count - 1) i = count - 1;
        track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      }
    });
  });
})();
